import {
    GET_ROLE_DETAIL_SUCCESS,
    GET_ROLE_DETAIL_FAILURE,
    UPDATE_ROLE_PERMISSION_SUCCESS,
    UPDATE_ROLE_PERMISSION_FAILURE,
} from "../actions/types";

const initialState = {
    roleDetails: null,
    error: null,
    updateSuccess: false,
};

const getUpdateRolesReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_ROLE_DETAIL_SUCCESS:
            return {
                ...state,
                roleDetails: action.payload,
                error: null,
            };
        case GET_ROLE_DETAIL_FAILURE:
            return {
                ...state,
                error: action.payload,
            };
        case UPDATE_ROLE_PERMISSION_SUCCESS:
            return {
                ...state,
                updateSuccess: true,
                error: null,
            };
        case UPDATE_ROLE_PERMISSION_FAILURE:
            return {
                ...state,
                updateSuccess: false,
                error: action.payload,
            };
        default:
            return state;
    }
};

export default getUpdateRolesReducer;
